import { redirectToHomeIfNotAdmin } from '@/data-integrations/router/guards';

const DataIntegrationConfigDashboardPage = () =>
  import('@/data-integrations/pages/data-integration-config-dashboard.vue');

export const dataIntegrationsRoutes = [
  {
    path: '/data-integrations/:id',
    name: 'data-integrations-config',
    component: DataIntegrationConfigDashboardPage,
    beforeEnter: redirectToHomeIfNotAdmin,
    meta: {
      layout: 'layout-empty',
    },
  },
];
